import React from 'react'
import {connect} from 'react-redux'

import '../../asset/less/Payment.css'

import {message, Select, Spin, Table, Tag, Typography} from 'antd'
import {deleteArtistPayments, getArtistPayments, patchArtistPayments} from '../../api/artistPayments'
import {getAllArtistNames} from '../../api/artistNames'
import GalleryTablePanel from "../../component/GalleryTablePanel";
import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";
import {withRouter} from "react-router-dom";
import {URL_NEW_PAYMENT, URL_ORDER_DETAILS} from "../../const";
import {getEditUrl} from '../../component/Utils'
import HttpError from "../../component/base/HttpError";
import {is_admin_user} from "../../app/role";

const {Title} = Typography
const {Option} = Select
const {Column} = Table

@connect((state) => ({
    id: state.user.info.id,
    artistId: state.user.info.artistId,
    role: state.user.info.role,
}))

class Payment extends React.Component {
    export
    default

    constructor(props) {
        super(props)
        this.addFormRef = React.createRef()
        this.state = {
            dataSource: [],
            selectedRowKeys: [], //To perform operations and clear selections after selecting some rows, use rowSelection.selectedRowKeys to control selected rows.
            loading: false,
            status: [],
            artistNames: [],
            verifyStatus: {}
        }

        const artistColumns = [
            {
                title: '#ID',
                dataIndex: 'id',
                key: 'id',
                editable: false,
                width: 96,
                ellipsis: true,
                render: (text) => <>#{text}</>
            },
            {
                title: '#Order ID',
                dataIndex: 'order_num',
                key: 'order_num',
                editable: false,
                width: 128,
                ellipsis: true,
                render: (text, record) => <a target={'_blank'} rel={'noreferrer'}
                                             href={this.getOrderDetailsUrl(text)}>#{text}</a>
            },
            {
                title: 'Total Payment',
                dataIndex: 'pay_to_artist',
                key: 'pay_to_artist',
                editable: false,
                width: 168,
                align: 'center',
                ellipsis: true,
                render: (text) => <>${Number(parseFloat(text)).toLocaleString()}</>
            },
            {
                title: 'Update at',
                dataIndex: 'last_updated',
                key: 'last_updated',
                editable: false,
                width: 128,
                ellipsis: true
            },
            {
                title: 'Artwork Price',
                dataIndex: 'artwork_price',
                key: 'artwork_price',
                editable: false,
                width: 148,
                align: 'center',
                ellipsis: true,
                render: (text) => <>${Number(parseFloat(text)).toLocaleString()}</>
            },
            {
                title: 'RevArt Commission',
                dataIndex: 'revart_commission',
                key: 'revart_commission',
                editable: false,
                width: 200,
                align: 'center',
                ellipsis: true,
                render: (text) => <>${Number(parseFloat(text)).toLocaleString()}</>
            },
        ]

        function getName(ins, text) {
            if (!ins.state.artistNames) return ""
            const filter = ins.state.artistNames?.filter((name) => {
                return name.artist_id?.toString() === text.toString()
            })
            if (filter.length === 0) return ""
            return filter[0].name
        }

        const adminColumns = [
            {
                title: 'Artist Name',
                dataIndex: 'artist',
                key: 'artist',
                editable: false,
                width: 188,
                ellipsis: true,
                render: (text) => <>{getName(this, text)}</>
            },
            ...artistColumns,
        ]

        this.columns = is_admin_user(this.props) ? [this.displayStatusColumn(false),
            ...adminColumns] : [this.displayStatusColumn(true), ...artistColumns]

        this.filterOptions = {}

        this.paymentSortOptions = [
            {
                text: 'Payment ID (Ascending)',
                value: 'id',
                icon: <ArrowUpOutlined/>
            },
            {
                text: 'Payment ID (Descending)',
                value: '-id',
                icon: <ArrowDownOutlined/>
            },
            {
                text: 'Date (Oldest)',
                value: 'last_updated',
                icon: <ArrowUpOutlined/>
            },
            {
                text: 'Date (Newest)',
                value: '-last_updated',
                icon: <ArrowDownOutlined/>
            },
            {
                text: 'Total Payment (Highest)',
                value: '-pay_to_artist',
                icon: <ArrowUpOutlined/>
            },
            {
                text: 'Total Payment (Lowest)',
                value: 'pay_to_artist',
                icon: <ArrowDownOutlined/>
            },
        ]
    }

    getOrderDetailsUrl = (id) => {
        return getEditUrl(URL_ORDER_DETAILS, id)
    }

    componentDidMount() {
        if (is_admin_user(this.props)) {
            this.setState({loading: true})
            getAllArtistNames().then((response) => {
                const artists = response.data
                this.setState(
                    {
                        artistNames: artists
                    },
                )
            }).finally(() => {
                this.setState({
                    loading: false
                })
            })
        }
    }

    requestData = (pageId, pageSize, sort, filters, search, cancelToken) => {
        return getArtistPayments(pageId, pageSize, sort, filters, search, this.props.artistId, cancelToken)
    }

    deleteAllHandler = () => {
        const length = this.state.selectedRowKeys.length
        let sortedRowKeys = this.state.selectedRowKeys.sort((a, b) => a - b)
        let request
        for (let i = length - 1; i >= 0; i--) {
            let index = this.findWithId(this.state.dataSource, sortedRowKeys[i])
            request = deleteArtistPayments(sortedRowKeys[i])
            request
                .then((response) => {
                    this.state.dataSource.splice(index, 1)
                    this.state.status.splice(index, 1)
                    this.setState({
                        dataSource: this.state.dataSource,
                        status: this.state.status
                    })
                    message.success('Deleted successfully').then((r) => {
                    })
                })
                .catch((error) => {
                    message.error(error.message).then((r) => {
                    })
                })
        }
        window.location.reload()
    }

    findWithId(array, id) {
        for (let i = 0; i < array.length; i += 1) {
            if (array[i].id == id) {
                return i
            }
        }
        return -1
    }

    displayStatusColumn = (artist) => {
        //artist is a boolean indicating whether artist/admin
        const map = {
            unverified: 'Unpaid',
            initiated: 'Unpaid',
            'payment-processing': 'Unpaid',
            'payment-settled': 'Paid',
            'paid': 'Paid',
            'partially-paid': 'Partially Paid',
            'refunded': 'Refunded',
            'unpaid': 'Unpaid',
        }

        const colorMap = {
            unverified: 'error',
            initiated: 'default',
            'payment-processing': 'default',
            'payment-settled': 'success',
            'paid': 'success',
            'partially-paid': 'success',
            'refunded': 'processing',
            'unpaid': 'default',
        }

        if (artist) {
            return (
                {
                    title: 'Status',
                    key: 'action',
                    dataIndex: 'pay_status',
                    align: 'center',
                    width: 200,
                    render: (text, record, index) => {
                        return <Tag color={colorMap[record.pay_status]}>{map[record.pay_status]}</Tag>
                    }
                }
            )
        } else {
            return (
                {
                    title: 'Status',
                    key: 'action',
                    dataIndex: 'pay_status',
                    align: 'center',
                    width: 200,
                    onFilter: (value, record) => {
                        return record.pay_status.includes(value)
                    },
                    filters: [
                        {text: 'Paid', value: 'paid'},
                        {text: 'Partially Paid', value: 'partially-paid'},
                        {text: 'Refunded', value: 'refunded'},
                        {text: 'Unpaid', value: 'unpaid'}
                    ],
                    render: (text, record, index) => {
                        return (
                            <Select style={{minWidth: 160}} defaultValue={record.pay_status}
                                    onChange={(value) => this.handleStatusChange(record, value)}>
                                <Option value='unverified'>Unverified</Option>
                                <Option value='initiated'>Initiated</Option>
                                <Option value='payment-processing'>Payment Processing</Option>
                                <Option value='payment-settled'>Payment Settled</Option>
                            </Select>
                        )
                    }
                }
            )
        }
    }

    handleStatusChange(record, value) {
        if (!record.id) {
            HttpError({msg: "invalid id"})
            return
        }
        let today = new Date()
        const dd = String(today.getDate()).padStart(2, '0')
        const mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
        const yyyy = today.getFullYear()
        today = yyyy + '-' + mm + '-' + dd

        let request
        request = patchArtistPayments(record.id, {
            pay_status: value,
            last_updated: today,
        })
        request
            .then((response) => {
                message.success('Update successful').then((r) => {
                })
            })
            .catch((error) => {
                HttpError(error)
            })
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <GalleryTablePanel artistId={this.props.artistId}
                                   requestData={this.requestData}
                                   faqLink={'https://revart.co/webstatic/assets/demo/aboutus/revart_payment_faq.pdf'}
                                   name={'payment'}
                                   columns={this.columns} tableWidth={1200}
                                   viewOptions={['table']}
                                   filterOptions={this.filterOptions}
                                   disableAdd={!is_admin_user(this.props)}
                                   disableImport={true}
                                   sortOptions={this.paymentSortOptions}
                                   defaultSortOption={this.paymentSortOptions[1].value}
                                   exportFileName={'payment'}
                                   addNewUrl={URL_NEW_PAYMENT}
                />
            </Spin>
        )
    }

}

export default withRouter(Payment);
